module.exports = __webpack_public_path__ + "img/system.244960f5.png";